import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-super-admin-header',
  templateUrl: './super-admin-header.component.html',
  styleUrls: ['./super-admin-header.component.scss']
})
export class SuperAdminHeaderComponent {
    @Input() workspaceRoute!: string;
  @Input() insightsRoute!: string;
  
    // Variable to hold the workspace name
    workspace: string = 'Workspace'; // Default value (optional)
    insights: string = 'insights'
  
    constructor() {}
  
}
